import { useTranslation } from "@/hooks/useTranslation"
import { StatusTag } from "@/molecules/StatusTag"

import type { AiPolicyAction } from "@/api/useAiPolicies.types"

// The violated policy's action: it blocks, or only monitors
export const AiPolicyActionTag = ({ action }: { action: AiPolicyAction }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.enforce.status"
  })
  const isEnforced = action === "BLOCK"

  return (
    <StatusTag
      status={isEnforced ? "success" : "neutral"}
      text={t(isEnforced ? "enforced" : "monitor")}
    />
  )
}
